/*
 * @Author: Teemo Ding
 * @Date: 2021-10-21 15:55:54
 * @LastEditTime: 2021-10-22 17:23:20
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelMiniProgramSetting/Components/ScanQRCode/index.tsx
 */
import { Image } from '@/src/components/Antd';
import React from 'react';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';
const ScanQRCode = ({ url }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <div className={css.uploadCodeVersion}>
      <Image
        key={url}
        src={url}
        width={240}
        height={240}
        className={css.uploadCodeVersionImage}
      />
      <p className={css.uploadCodeVersionText}>
        {getI18n('salesChannelMiniProgramSettings.index.scanQRCode')}
      </p>
    </div>
  );
};

export default ScanQRCode;
